import React, { Component } from 'react';
import { AppProvider } from '@shopify/polaris';
import { Provider } from '@shopify/app-bridge-react';
import createApp from "@shopify/app-bridge";
import { Redirect } from '@shopify/app-bridge/actions';
import { getFetch } from '../helpers/request';


interface LoginPageProps { }

interface LoginPageState { 
  shopOrigin: string,
  apiKey: string
}

class LoginPage extends Component <LoginPageProps, LoginPageState> {

  constructor(props: LoginPageProps) {
    super(props);
    this.state = { 
      shopOrigin: '',
      apiKey: ''
    };
  }

  componentDidMount() {
    console.log('\n=== LOGINPAGE COMPONENT MOUNT START ===');
    let shopHost = new URLSearchParams(window.location.search).get("host");
    console.log('Shop Host from URL:', shopHost);
    console.log('Current URL:', window.location.href);
    console.log('API Key available:', !!(window as any).apiKey);
    
    console.log('Making API call to /app/api/shopify/auth...');
    getFetch('/app/api/shopify/auth', {})
      .then((res: any) => {
        console.log('API Response received:');
        console.log('- Status:', res.status);
        console.log('- Status Text:', res.statusText);
        console.log('- Headers:', res.headers);
        
        if (res.status === 403) {
          console.log('403 response detected, parsing JSON for error details...');
          return res.json().then((errorData: any) => {
            console.log('Error data:', errorData);
            if (errorData.error === 'permission_required') {
              console.log('🔄 Permission required detected!');
              console.log('Permission URL:', errorData.permission_url);
              console.log('Shop:', errorData.shop);
              console.log('Redirecting to Shopify for additional permissions...');
              if (window.top) {
                window.top.location.href = errorData.permission_url;
              } else {
                window.location.href = errorData.permission_url;
              }
              return Promise.reject('permission_redirect');
            }
            console.log('Other 403 error:', errorData);
            throw new Error('Authorization failed');
          });
        }
        
        if (res.ok) {
          console.log('Successful response, parsing JSON...');
          return res.json();
        } else {
          console.log('Non-OK response:', res.status);
          throw new Error('API request failed');
        }
      })
      .then((data: any) => {
          console.log('Auth API data received:', data);
          console.log('User uninstalled status:', data.uninstalled);
          
          const app:any = createApp({
            host:shopHost!,
            apiKey: (window as any).apiKey,
          });
          console.log('App Bridge app created');
          
          const redirect = Redirect.create(app);
          if (data.uninstalled) {
            console.log('User is uninstalled, redirecting to /app');
            redirect.dispatch(Redirect.Action.APP, '/app');
          } else {
            console.log('User is installed, redirecting to /collection-listing');
            redirect.dispatch(Redirect.Action.APP, '/collection-listing');
          }
          console.log('=== LOGINPAGE COMPONENT MOUNT END - SUCCESS ===\n');
        }).catch((err: any) => {
            if (err !== 'permission_redirect') {
              console.log('💥 Error in auth flow:', err);
              console.log('Redirecting to app login page');
            window.location.href = this.getRedirectURL();
            } else {
              console.log('Permission redirect initiated, not doing fallback redirect');
            }
            console.log('=== LOGINPAGE COMPONENT MOUNT END - ERROR ===\n');
        });
  }
  
  render() {
    const config = {apiKey: this.state.apiKey, shopOrigin: this.state.shopOrigin, host:Buffer.from('admin.shopify.com/store/' + this.state.shopOrigin.split('.')[0]).toString('base64')};
    return (
        this.state.shopOrigin !== '' && this.state.apiKey !== '' && 
        <AppProvider i18n={{}}>
          <Provider config={config}>
            
          </Provider>
        </AppProvider>
    );
  }

  getRedirectURL() {
    const queryString = window.location.href.split('?')[1];
    return '/app?' + queryString;
  }
}

export default LoginPage;